var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.390869 15.6938L3.94234 18.2531L3.92313 15.3L0.390869 15.6938Z",
    fill: "#4B5916"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 8.92236V34.2913C29.9702 35.2353 29.2052 36 28.2616 36H5.65105C4.70746 36 3.94238 35.2353 3.94238 34.2913V1.70901C3.94238 0.765073 4.70746 0 5.65105 0H20.426L29.9702 8.92236Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9682 7.16479H0.708828C0.317353 7.16479 0 7.48215 0 7.87362V15.0604C0 15.4519 0.317353 15.7692 0.708828 15.7692H16.9682C17.3597 15.7692 17.677 15.4519 17.677 15.0604V7.87362C17.677 7.48215 17.3597 7.16479 16.9682 7.16479Z",
    fill: "#73931C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66139 14.0801V9.83239H3.21753V9.08374H6.99154V9.83239H5.54768V14.0801H4.66139Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1365 14.0801L8.5573 11.5054L7.22803 9.08374H8.21354L8.76342 10.1915C8.82455 10.3086 8.88429 10.4284 8.94298 10.5507C9.00132 10.6729 9.0691 10.8078 9.1456 10.9555H9.176C9.23713 10.8078 9.29443 10.6729 9.34788 10.5507C9.40133 10.4284 9.45618 10.3089 9.51207 10.1915L10.0392 9.08374H10.979L9.64971 11.5439L11.0705 14.0801H10.085L9.47399 12.9035C9.40762 12.7711 9.34264 12.6401 9.27905 12.5101C9.21512 12.3802 9.14526 12.2391 9.0691 12.086H9.03835C8.97198 12.2387 8.90979 12.3802 8.8511 12.5101C8.79241 12.6401 8.73267 12.7711 8.67154 12.9035L8.07555 14.0801H7.1358H7.1365Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 14.0801V9.83239H11.2162V9.08374H14.9902V9.83239H13.5463V14.0801H12.66Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9703 8.92236V9.18646H21.4676C20.8185 9.18646 20.292 8.66 20.292 8.01056V0H20.4261L29.9703 8.92236Z",
    fill: "#E6E7E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 18.5474H8.75439V19.9615H25.1587V18.5474Z",
    fill: "#E6E7E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 21.8062H8.75439V23.2203H25.1587V21.8062Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 25.0647H8.75439V26.4789H25.1587V25.0647Z",
    fill: "#E6E7E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 28.3235H8.75439V29.7376H25.1587V28.3235Z",
    fill: "#E6E7E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 31.5823H8.75439V32.9964H25.1587V31.5823Z",
    fill: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtMessage);
export default __webpack_public_path__ + "static/media/txt_message.574741928ff6c667b57f83426baff480.svg";
export { ForwardRef as ReactComponent };